// auth.js
export const LOGOUT = "LOGOUT";
export const SAVE_TOKEN = "SAVE_TOKEN";
export const FETCH_USER = "FETCH_USER";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILURE = "FETCH_USER_FAILURE";
export const FETCH_USER_SUBSCRIPTION = "FETCH_USER_SUBSCRIPTION";
export const UPDATE_USER = "UPDATE_USER";

export const TOGGLE_MARKET = "TOGGLE_MARKET";
export const UPDATE_MARKET_ALLOCATION = "UPDATE_MARKET_ALLOCATION";

export const UPDATE_MARKET = "UPDATE_MARKET";

export const FETCH_MARKETS_SUCCESS = "FETCH_MARKETS_SUCCESS";
export const FETCH_MARKETS_FAILURE = "FETCH_MARKETS_FAILURE";

export const FETCH_APIKEYS_SUCCESS = "FETCH_APIKEYS_SUCCESS";
export const FETCH_APIKEYS_FAILURE = "FETCH_APIKEYS_FAILURE";

export const FETCH_WHITELABEL_PAYMENTS_SUCCESS = "FETCH_WHITELABEL_PAYMENTS_SUCCESS";
export const FETCH_WHITE_LABEL_FAILURE = "FETCH_WHITELABEL_PAYMENTS_FAILURE";

export const FETCH_ACCOUNTS_DEPOSITS_SUCCESS = "FETCH_ACCOUNTS_DEPOSITS_SUCCESS";
export const FETCH_ACCOUNTS_DEPOSITS_FAILURE = "FETCH_ACCOUNTS_DEPOSITS_FAILURE";

export const FETCH_MARKETS_ALL_SUCCESS = "FETCH_MARKETS_ALL_SUCCESS";
export const FETCH_MARKETS_ALL_FAILURE = "FETCH_MARKETS_ALL_FAILURE";

export const SEED_MARKET_DATA_ALLOCATION = "SEED_MARKET_DATA_ALLOCATION";

export const FETCH_MARKETS_PROFITS_LAST_MONTH_SUCCESS = "FETCH_MARKETS_PROFITS_LAST_MONTH_SUCCESS";
export const FETCH_MARKETS_PROFITS_LAST_MONTH_FAILURE = "FETCH_MARKETS_PROFITS_LAST_MONTH_FAILURE";

export const FETCH_MARKETS_PROFITS_SUCCESS = "FETCH_MARKETS_PROFITS_SUCCESS";
export const FETCH_MARKETS_PROFITS_FAILURE = "FETCH_MARKETS_PROFITS_FAILURE";
export const SEED_MARKET_PROFITS_DATA_ALLOCATION = "SEED_MARKET_PROFITS_DATA_ALLOCATION";

export const FETCH_ALLOCATIONS_SUCCESS = "FETCH_ALLOCATIONS_SUCCESS";
export const FETCH_ALLOCATIONS_FAILURE = "FETCH_ALLOCATIONS_FAILURE";
export const FETCH_ALLOCATIONS_START = "FETCH_ALLOCATIONS_START";

// Dashboard
export const FETCH_TRADE_DETAILS_SUCCESS = "FETCH_TRADE_DETAILS_SUCCESS";
export const FETCH_TRADE_DETAILS_FAILURE = "FETCH_TRADE_DETAILS_FAILURE";

// Settings
export const SET_DARKMODE = "SET_DARKMODE";
export const FETCH_ALL_TRADE_ENGINE_STATUS_SUCCESS = "FETCH_ALL_TRADE_ENGINE_STATUS_SUCCESS";
export const FETCH_ALL_TRADE_ENGINE_STATUS_FAILURE = "FETCH_ALL_TRADE_ENGINE_STATUS_FAILURE";

// User History
export const USER_HISTORY_SUCCESS = "USER_HISTORY_SUCCESS";
export const USER_HISTORY_FAILURE = "USER_HISTORY_FAILURE";

//Version
export const VERSION_INFO_SUCCESS = "VERSION_INFO_SUCCESS";
export const VERSION_INFO_FAILURE = "VERSION_INFO_FAILURE";

//Subdcriptions
export const FETCH_SUBSCRIPTIONS_SUCCESS = "FETCH_SUBSCRIPTIONS_SUCCESS";
export const FETCH_SUBSCRIPTIONS_FAILURE = "FETCH_SUBSCRIPTIONS_FAILURE";



// WEBPACK FOOTER //
// ./resources/js/store/mutation-types.js